import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from 'hooks/apollo';
import { Tooltip } from '@mui/material';
import { EXPORT_REPORT_LIST } from '../mutations';
import { REPORTS_LIST_FILTERS_QUERY } from '../queries';
import { buildExportDownloadUrl } from 'features/downloadList/api';
import { CloudDownload } from '@mui/icons-material';
import { fileType } from 'constants/fileTypes';
import { useSimpleError } from 'hooks/apolloWrappers';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { convertBase64ToFile } from 'utils/base64FileConversion';
import saveAs from 'file-saver';
import { IconButton } from '@totalsoft/rocket-ui';
import { getOidcConfigName } from 'utils/functions';
import { useOidcAccessToken } from '@axa-fr/react-oidc';

const ExportAction = () => {
  const [t] = useTranslation();
  const classes = { temp: 'temp' };
  const showError = useSimpleError();
  const [filters, setFilters] = useState({});
  const { accessToken } = useOidcAccessToken(getOidcConfigName());

  const [exportAnchorEl, setShowHandleClose] = useState(null);
  const isExportOpen = Boolean(exportAnchorEl);

  const [exportReportList] = useMutation(EXPORT_REPORT_LIST, {
    onCompleted: async ({ exportReportList }) => {
      let downloadLink = null;
      try {
        if (exportReportList.fileBytes) {
          saveAs(convertBase64ToFile(exportReportList.fileBytes), exportReportList.fileName);
          return;
        }
        downloadLink = await buildExportDownloadUrl(exportReportList.filePath, exportReportList.fileName, accessToken);
      } catch (error) {
        showError(error);
      }
      if (downloadLink) {
        window.location.href = downloadLink;
      }
    }
  });

  useQuery(REPORTS_LIST_FILTERS_QUERY, {
    onCompleted: data => {
      if (data)
        setFilters({
          reportFriendlyName: data.reportsFilters.reportFriendlyName.value,
          reportName: data.reportsFilters.reportName.value,
          fullTextFilter: data.reportsFilters.fullTextFilter.value
        });
    }
  });

  const onExport = filters => {
    exportReportList({ variables: { filters } });
  };

  const handleExportClose = () => {
    setShowHandleClose(null);
  };

  const handleExportClick = event => {
    setShowHandleClose(event.currentTarget);
  };

  const handleExport = (fileType, filters) => () => {
    onExport({ ...filters, fileType });
    setShowHandleClose(null);
  };

  return (
    <Tooltip placement='top' title={t('Tooltips.DownloadReportList')}>
      <div>
        <IconButton color='primary' onClick={handleExportClick} className={classes.actionButton}>
          <CloudDownload />
        </IconButton>
        <Menu id='render-export-menu' anchorEl={exportAnchorEl} open={isExportOpen} onClose={handleExportClose}>
          <MenuItem onClick={handleExport(fileType.excel, filters)}>{t('Export.Excel')}</MenuItem>
          <MenuItem onClick={handleExport(fileType.csv, filters)}>{t('Export.CSV')}</MenuItem>
        </Menu>
      </div>
    </Tooltip>
  );
};

export default ExportAction;
